import {httpClientV2} from "../../../../infrastructure/http";
import {
  BookingActionsRepository,
  BookingActor,
  CancelBookingCommand,
  RescheduleBookingCommand,
} from "../../domain/types";
import {BookingActionsMapperV2} from "../mappers/mapper.v2";

/**
 * v2 API implementation of BookingActionsRepository.
 *
 * Both actors share one verb (PUT), one body shape per operation, and differ only
 * by namespace:
 *
 *   coach:    PUT bookings/:reference/{cancel,reschedule}
 *   customer: PUT customer/bookings/:reference/{cancel,reschedule}
 *
 * The server resolves bundle vs one-off from the reference, and decrements the
 * bundle's booked-session count on cancel.
 *
 * Note: these routes sit behind the backend's own FEATURE_BOOKING_SERVICES_ENABLED
 * flag, which is independent of the client flag selecting this repository.
 *
 * Pure TypeScript - no React imports.
 */
export class BookingActionsRepositoryV2 implements BookingActionsRepository {
  private basePath(actor: BookingActor, reference: string): string {
    return actor === "coach" ? `bookings/${reference}` : `customer/bookings/${reference}`;
  }

  async cancelBooking(command: CancelBookingCommand): Promise<void> {
    await httpClientV2.put(
      `${this.basePath(command.actor, command.reference)}/cancel`,
      BookingActionsMapperV2.toCancelRequest(command)
    );
  }

  async rescheduleBooking(command: RescheduleBookingCommand): Promise<void> {
    await httpClientV2.put(
      `${this.basePath(command.actor, command.reference)}/reschedule`,
      BookingActionsMapperV2.toRescheduleRequest(command)
    );
  }
}
